<div
  class="items-brew-dialog"
  [ngClass]="{ fh: settingsManager.settings.theme === 'fh', modern: settingsManager.settings.theme === 'modern' }"
>
  <div class="scroll-container">
    <div class="header">
      <div class="title">
        <span [ghs-label]="'game.items.brewing'"></span>

        <span
          class="grid-mode"
          [ghs-tooltip]="'game.items.brewing.' + (settingsManager.settings.fhBrewGrid ? 'table' : 'grid')"
          (click)="settingsManager.toggle('fhBrewGrid')"
        >
          <img [src]="'./assets/images/' + (settingsManager.settings.fhBrewGrid ? 'table' : 'grid') + '.svg'" />
        </span>
      </div>

      @if (gameManager.itemManager.brewingDisabled()) {
        <span class="brewing-disabled">
          <img src="./assets/images/close.svg" /> <span [ghs-label]="'game.items.brewing.disabled'"></span>
        </span>
      }
    </div>

    @if (!settingsManager.settings.fhBrewGrid) {
      <div class="table" [style.--ghs-summary-columns]="2 + brewing + (!character || settingsManager.settings.fhShareResources ? -1 : 0)">
        @for (i of [] | ghsRange: brewing; track i) {
          <span class="head-col first">{{ i + 1 }}.</span>
        }
        @if (!!character && !settingsManager.settings.fhShareResources) {
          <span class="first">
            <img class="icon character-icon" [src]="character.iconUrl" />
            <span class="name" [ngClass]="{ absent: character.absent }">
              {{ gameManager.characterManager.characterName(character) }}
            </span>
          </span>
        }
        <span class="first"><span [ghs-label]="'party.campaign.sheet.supply'"></span></span>

        @for (herb of herbs; track herb) {
          <span
            class="head-col calc-col toggle"
            [ghs-tooltip]="'game.loot.' + herb"
            [ngClass]="{
              active: receipe.length > 0 && receipe[0] === herb,
              disabled:
                receipe[0] !== herb &&
                ((!!character && character.progress.loot[herb]) || 0) === 0 &&
                (gameManager.game.party.loot[herb] || 0) === 0,
              spent:
                receipe[0] !== herb &&
                ((characterSpent[herb] || 0) > 0 || (fhSupportSpent[herb] || 0) > 0) &&
                ((!!character && character.progress.loot[herb]) || 0) <= (characterSpent[herb] || 0) &&
                (gameManager.game.party.loot[herb] || 0) <= (fhSupportSpent[herb] || 0),
              forced: forced[0]
            }"
            ghs-pointer-input
            (singleClick)="toggleHerb(herb, 0)"
            (doubleClick)="toggleHerb(herb, 0, true)"
          >
            <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herb + '.svg'" />
          </span>
          <span
            class="head-col calc-col toggle"
            [ghs-tooltip]="'game.loot.' + herb"
            [ngClass]="{
              active: receipe.length > 1 && receipe[1] === herb,
              disabled:
                receipe[1] !== herb &&
                ((!!character && character.progress.loot[herb]) || 0) === 0 &&
                (gameManager.game.party.loot[herb] || 0) === 0,
              spent:
                receipe[1] !== herb &&
                ((characterSpent[herb] || 0) > 0 || (fhSupportSpent[herb] || 0) > 0) &&
                ((!!character && character.progress.loot[herb]) || 0) <= (characterSpent[herb] || 0) &&
                (gameManager.game.party.loot[herb] || 0) <= (fhSupportSpent[herb] || 0),
              forced: forced[1]
            }"
            ghs-pointer-input
            (singleClick)="toggleHerb(herb, 1)"
            (doubleClick)="toggleHerb(herb, 1, true)"
          >
            <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herb + '.svg'" />
          </span>
          @if (brewing === 3) {
            <span
              class="head-col calc-col toggle"
              [ghs-tooltip]="'game.loot.' + herb"
              [ngClass]="{
                active: receipe.length > 2 && receipe[2] === herb,
                disabled:
                  receipe[2] !== herb &&
                  ((!!character && character.progress.loot[herb]) || 0) === 0 &&
                  (gameManager.game.party.loot[herb] || 0) === 0,
                spent:
                  receipe[2] !== herb &&
                  ((characterSpent[herb] || 0) > 0 || (fhSupportSpent[herb] || 0) > 0) &&
                  ((!!character && character.progress.loot[herb]) || 0) <= (characterSpent[herb] || 0) &&
                  (gameManager.game.party.loot[herb] || 0) <= (fhSupportSpent[herb] || 0),
                forced: forced[2]
              }"
              ghs-pointer-input
              (singleClick)="toggleHerb(herb, 2)"
              (doubleClick)="toggleHerb(herb, 2, true)"
            >
              <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herb + '.svg'" />
            </span>
          }
          @if (!!character && !settingsManager.settings.fhShareResources) {
            <span class="calc-col">
              @if (character.progress.loot[herb]) {
                <span class="value" [ghs-label]="'game.loot.'" [ghs-label-attribute]="'title'">
                  {{ characterSpent[herb] || '-' }} / {{ character.progress.loot[herb] || 0 }}
                </span>
                @if (characterSpent[herb] && (gameManager.game.party.loot[herb] || 0) > (fhSupportSpent[herb] || 0)) {
                  <a class="button" (click)="moveHerb(herb, characterSpent, fhSupportSpent)">
                    <img class="ghs-svg" src="./assets/images/right.svg" />
                  </a>
                }
              }
              @if (!character.progress.loot[herb]) {
                <span>-</span>
              }
            </span>
          }
          <span class="calc-col">
            @if (gameManager.game.party.loot[herb]) {
              @if (fhSupportSpent[herb] && ((!!character && character.progress.loot[herb]) || 0) > (characterSpent[herb] || 0)) {
                <a class="button" (click)="moveHerb(herb, fhSupportSpent, characterSpent)">
                  <img class="ghs-svg" src="./assets/images/left.svg" />
                </a>
              }
              <span class="value" [ghs-label]="'game.loot.'" [ghs-label-attribute]="'title'">
                {{ fhSupportSpent[herb] || '-' }} / {{ gameManager.game.party.loot[herb] || 0 }}
              </span>
            }
            @if (!gameManager.game.party.loot[herb]) {
              <span>-</span>
            }
          </span>
        }
      </div>
    }

    @if (settingsManager.settings.fhBrewGrid) {
      <div class="grid" [ngClass]="{ hidden: receipe[0] && receipe[1] && receipe[2] }">
        <div class="grid-row">
          <span class="grid-corner"></span>
          @for (herb of herbs; track herb; let hi = $index) {
            <span class="grid-head grid-head-top" [ngClass]="{ disabled: herbTotals[hi] === 0 }">
              <span class="label icon" [ghs-tooltip]="'game.loot.' + herb">
                @if (herbTotals[hi]) {
                  <span class="value">{{ herbTotals[hi] }}</span>
                }
                <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herb + '.svg'" />
              </span>
            </span>
          }
        </div>
        @for (i of [] | ghsRange: herbs.length; track i) {
          <div class="grid-row">
            <span class="grid-head grid-head-left" [ngClass]="{ disabled: herbTotals[herbs.length - 1 - i] === 0 }">
              <span class="label icon" [ghs-tooltip]="'game.loot.' + herbs[herbs.length - 1 - i]">
                @if (herbTotals[herbs.length - 1 - i]) {
                  <span class="value">{{ herbTotals[herbs.length - 1 - i] }}</span>
                }
                <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herbs[herbs.length - 1 - i] + '.svg'" />
              </span>
            </span>
            @for (j of [] | ghsRange: herbs.length - i; track j) {
              <span
                class="grid-cell toggle"
                [ngClass]="{ active: gridCellActive2[i][j], disabled: !gridCellActive2[i][j] && gridCellDisabled2[i][j] }"
                ghs-pointer-input
                (singleClick)="selectGridCombo(herbs[herbs.length - 1 - i], herbs[j])"
                (doubleClick)="selectGridCombo(herbs[herbs.length - 1 - i], herbs[j], undefined, true)"
              >
                @if (gridItems2[i][j]; as gridItem) {
                  <span
                    class="item-name text-white"
                    [ngClass]="{ disabled: gridItemsCount2[i][j] === 0 }"
                    [ghs-label]="'%data.items.' + gridItem.edition + '-' + gridItem.id + '%'"
                  ></span>
                  <span
                    class="item-number text-white"
                    [ngClass]="{ disabled: gridItemsCount2[i][j] === 0 }"
                    [ghs-label]="'%game.itemFh.' + gridItem.id + '%'"
                  ></span>
                }
              </span>
            }
          </div>
        }
      </div>
      @if (brewing === 3) {
        <div class="brewing3-subgrids">
          @for (ci of [] | ghsRange: 4 : true; track ci) {
            <div
              class="grid brewing3-subgrid brewing3-subgrid-{{ ci }}"
              [ngClass]="{ hidden: receipe[0] && receipe[1] && receipe[2] !== herbs[ci + 2] }"
            >
              <div class="grid-row">
                <span class="grid-corner">
                  <span class="grid-corner-container">
                    <span class="corner-herb" [ghs-tooltip]="'game.loot.' + herbs[ci + 2]">
                      <span
                        class="corner-herb-icon"
                        [style.mask-image]="'url(/assets/images/fh/loot/' + herbs[ci + 2] + '.svg)'"
                        [style.-webkit-mask-image]="'url(/assets/images/fh/loot/' + herbs[ci + 2] + '.svg)'"
                      >
                      </span>
                    </span>
                  </span>
                </span>
                @for (ti of [] | ghsRange: ci + 1; track ti) {
                  <span class="grid-head grid-head-top" [ngClass]="{ disabled: herbTotals[ti] === 0 }">
                    <span class="label icon" [ghs-tooltip]="'game.loot.' + herbs[ti]">
                      @if (herbTotals[ti]) {
                        <span class="value">{{ herbTotals[ti] }}</span>
                      }
                      <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herbs[ti] + '.svg'" />
                    </span>
                  </span>
                }
              </div>
              @for (li of [] | ghsRange: ci + 1; track li) {
                <div class="grid-row">
                  <span class="grid-head grid-head-left" [ngClass]="{ disabled: herbTotals[ci + 1 - li] === 0 }">
                    <span class="label icon" [ghs-tooltip]="'game.loot.' + herbs[ci + 1 - li]">
                      @if (herbTotals[ci + 1 - li]) {
                        <span class="value">{{ herbTotals[ci + 1 - li] }}</span>
                      }
                      <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herbs[ci + 1 - li] + '.svg'" />
                    </span>
                  </span>
                  @for (ti of [] | ghsRange: ci + 1 - li; track ti) {
                    <span
                      class="grid-cell toggle"
                      [ngClass]="{
                        active: gridCellActive3[ci][li][ti],
                        disabled: !gridCellActive3[ci][li][ti] && gridCellDisabled3[ci][li][ti]
                      }"
                      ghs-pointer-input
                      (singleClick)="selectGridCombo(herbs[ti], herbs[ci + 1 - li], herbs[ci + 2])"
                      (doubleClick)="selectGridCombo(herbs[ti], herbs[ci + 1 - li], herbs[ci + 2], true)"
                    >
                      @if (gridItems3[ci][li][ti]; as gridItem) {
                        <span
                          class="item-name text-white"
                          [ngClass]="{ disabled: gridItemsCount3[ci][li][ti] === 0 }"
                          [ghs-label]="'%data.items.' + gridItem.edition + '-' + gridItem.id + '%'"
                        ></span>
                        <span
                          class="item-number text-white"
                          [ngClass]="{ disabled: gridItemsCount3[ci][li][ti] === 0 }"
                          [ghs-label]="'%game.itemFh.' + gridItem.id + '%'"
                        ></span>
                      }
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
        <div class="grid brewing3-special" [ngClass]="{ hidden: receipe[0] && receipe[1] && !gridCellActiveSpecial3 }">
          <div class="grid-row">
            <span class="grid-corner"></span>
            <span class="grid-head grid-head-top" [ngClass]="{ disabled: gridCellDisabledSpecial3 }">
              <span class="label" [ghs-label]="'game.items.brewing.special3'"></span>
            </span>
          </div>
          <div class="grid-row">
            <span class="grid-head grid-head-left"></span>
            <span
              class="grid-cell toggle"
              [ngClass]="{ active: gridCellActiveSpecial3, disabled: !gridCellActiveSpecial3 && gridCellDisabledSpecial3 }"
              ghs-pointer-input
              (singleClick)="selectSpecial3()"
              (doubleClick)="selectSpecial3(true)"
            >
              @if (gridItemSpecial3; as gridItem) {
                <span class="item-name text-white" [ghs-label]="'%data.items.' + gridItem.edition + '-' + gridItem.id + '%'"></span>
                <span class="item-number text-white" [ghs-label]="'%game.itemFh.' + gridItem.id + '%'"></span>
              }
            </span>
          </div>
        </div>
      }
    }

    @if (!applied) {
      <div class="receipe">
        @for (herb of receipe; track '' + herb + i; let i = $index) {
          <span class="herb" ghs-pointer-input (singleClick)="removeHerb(herb, false)" (doubleClick)="removeHerb(herb, false, i)">
            @if (!!herb) {
              <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + herb + '.svg'" [ghs-tooltip]="'game.loot.' + herb" />
            }
            @if (!herb) {
              <img class="ghs-svg" src="./assets/images/fh/loot/unknown.svg" />
            }
            @if (i < receipe.length - 1) {
              <span>+</span>
            }
          </span>
        }
        @if (!brewed) {
          <span>=</span>
        }
        @if (!!item && !brewed) {
          <span
            class="placeholder text-white item"
            [ghs-label]="'game.items.brewing.item'"
            [ghs-label-args]="[item.id, item.edition]"
          ></span>
        }
        @if (!!brewed) {
          <span
            class="placeholder text-white item"
            [ghs-label]="'game.items.brewing.item'"
            [ghs-label-args]="[brewed.id, brewed.edition]"
          ></span>
        }
        @if (!item && !brewed) {
          <span class="herb">
            <img class="ghs-svg" src="./assets/images/fh/loot/unknown.svg" />
          </span>
        }
      </div>
    }

    @if (!!brewed || !!item) {
      <div class="brewed">
        <ghs-item
          [item]="brewed || item"
          [ngClass]="{ disabled: !brewed && !!item && countAvailable === 0 }"
          [count]="countAvailable"
          [flipped]="true"
          (click)="openItemDialog()"
        ></ghs-item>
      </div>
    }

    @if (!!brewed && selectedCharacter) {
      <div class="receipe">
        <span
          class="placeholder text-white item"
          [ghs-label]="'game.items.brewing.brewed' + (selectedCharacter !== character ? 'Other' : '')"
          [ghs-label-args]="[
            brewed.id,
            brewed.edition,
            (!!character && gameManager.characterManager.characterName(character, true)) || '',
            selectedCharacter !== character ? gameManager.characterManager.characterName(selectedCharacter, true) : ''
          ]"
        ></span>
      </div>
    }

    @if (!applied && characters.length > 0) {
      <div class="receipe">
        <span class="placeholder text-white item" [ghs-label]="'game.items.brewing.selectCharacter'"></span>
      </div>
      <div class="characters">
        @for (char of characters | trackUUID; track char._trackUUID) {
          <div class="character" (click)="selectedCharacter = char" [ngClass]="{ selected: selectedCharacter === char }">
            <img class="icon" [src]="char.iconUrl" />
            <span class="name">
              {{ gameManager.characterManager.characterName(char, true) }}
            </span>
          </div>
        }
      </div>
    }

    @if (characters.length === 0) {
      <div class="receipe">
        <span class="placeholder item already" [ghs-label]="'game.items.brewing.noChar'"></span>
      </div>
    }

    <div class="menu">
      <a class="cancel" (click)="close()"><span [ghs-label]="'cancel'"></span></a>
      <a
        class="apply"
        [ngClass]="{
          disabled:
            (!!item && countAvailable === 0) ||
            !selectedCharacter ||
            characters.length === 0 ||
            applied ||
            receipe.length < 2 ||
            !receipe[0] ||
            !receipe[1],
          unavailable: forced.includes(true) || gameManager.itemManager.brewingDisabled()
        }"
        ghs-pointer-input
        (singleClick)="brew()"
        (doubleClick)="brew(true)"
        ><span
          [ghs-label]="'game.items.brewing.brew' + (selectedCharacter !== character ? 'For' : '')"
          [ghs-label-args]="[selectedCharacter ? gameManager.characterManager.characterName(selectedCharacter, true) : '']"
        ></span
      ></a>
    </div>
  </div>
</div>
